import { Directive, ElementRef, EventEmitter, HostListener, Input, Output, Renderer2 } from '@angular/core';

@Directive({
    selector: '[cepMask]',
    standalone: false
})

export class CepMaskDirective {

    constructor(renderer: Renderer2, private element: ElementRef) {
        renderer.addClass(element.nativeElement, 'cepMask');
    }

    private emitted: string;

    @Input('cepMask') cepMask: string;
    @Output() cepMaskChange: EventEmitter<string> = new EventEmitter<string>();
    @Output() cepValidityChange: EventEmitter<boolean> = new EventEmitter<boolean>();
    cepType = '99999-999';

    @HostListener('keyup', ['$event'])
    onKeyup($event: any) {
        const value = $event.target.value.replace(/\D/g, '');

        if ($event.keyCode === 8 || $event.keyCode === 32 || $event.keyCode === 46) {
            this.emit($event.target.value);
            this.emitValidity(value);
            return value;
        }

        if (value.length <= 8) {
            $event.target.value = this.mascaraCep(value);
            if ($event.target.value.length === this.cepType.length) {
                this.emit($event.target.value);
            }
            this.emitValidity(value);
        } else if (value.length === 0) {
            this.emit($event.target.value);
            this.emitValidity(value);
        } else {
            return $event.target.value;
        }
    }

    emit(value: string) {
        if (value === this.emitted) return;
        this.emitted = value;
        this.cepMaskChange.emit(value);
    }

    emitValidity(value: string) {
        const isValid = this.isValidCep(value);
        this.cepValidityChange.emit(isValid);
    }

    isValidCep(value: string): boolean {
        // Verifique se o valor tem 8 dígitos.
        return /^\d{8}$/.test(value);
    }

    mascaraCep(value: string): string {
        value = value.replace(/\D/g, '');
        const replacement = this.cepType.replace(/\D/g, '').replace(/9/g, '_');
        const valueMask = value + replacement.substring(0, replacement.length - value.length);
        let valueMaskPos = 0;
        value = '';
        for (let i = 0; i < this.cepType.length; i++) {
            if (isNaN(parseInt(this.cepType.charAt(i)))) {
                value += this.cepType.charAt(i);
            } else {
                value += valueMask[valueMaskPos++];
            }
        }
        if (value.indexOf('_') > -1) {
            value = value.substr(0, value.indexOf('_'));
        }
        return value;
    }
}